SiteIndicateurValidator.$inject = ['validator'];

export default function SiteIndicateurValidator(validator) {
    const instance = new validator();

    return instance;
}
